import {appConfig} from '../config'
import type {CreativeBlockParams, ParcelSize} from '../types'
import {
  FALLBACK_DEFAULT_BDUI_VERTICALS,
  FALLBACK_DEFAULT_VERTICALS_WITH_ADDITIONAL_OPTIONS,
  FALLBACK_PARCEL_SIZES,
} from './consts'

export const experiments = {
  isBusinessToggleVisible: getBooleanConfigValue(
    appConfig.experiments3?.delivery_frontend_order_business_toggle_visibility?.enabled,
  ),
  bduiDebounceDuration: getNumberConfigValue(appConfig.experiments3?.delivery_order_bdui_debounce_duration?.value),
  verticalsWithAdditionalOptions: getVerticalsWithAdditionalOptions(),
  parcelSizes: getParcelSizes(),
  bduiVerticals: getBduiVerticals(),
  isBduiEnabled: getIsBduiEnabled(),
  shouldShowGutsRevealer: getShouldShowGutsRevealer(),
  creativeBlock: getCreativeBlock(),
}

function getNumberConfigValue(configValue?: unknown): number | undefined {
  /** явно типизируем конфиги, в которых ожидаем число */
  return typeof configValue === 'number' ? configValue : undefined
}

function getBooleanConfigValue(configValue?: unknown): boolean {
  /** явно приводим значение конфига к true или false, т.к. в конфиге может прийти произвольный JSON */
  return configValue === true
}

function getVerticalsWithAdditionalOptions(): string[] {
  const verticals = appConfig.experiments3?.delivery_verticals_enabled_additional_options?.enabled_verticals
  return verticals ?? FALLBACK_DEFAULT_VERTICALS_WITH_ADDITIONAL_OPTIONS
}

function getParcelSizes(): ParcelSize[] {
  const parcelSizes = appConfig.experiments3?.frontend_order_parcel_sizes?.parcels
  return parcelSizes ?? FALLBACK_PARCEL_SIZES
}

function getBduiVerticals(): string[] {
  const verticals = appConfig.experiments3?.delivery_order_form_bdui_verticals?.enabled_verticals
  return verticals ?? FALLBACK_DEFAULT_BDUI_VERTICALS
}

function getIsBduiEnabled(): boolean {
  return appConfig.experiments3?.bdui_external_order_switch?.enabled ?? false
}

function getShouldShowGutsRevealer(): boolean {
  const gutsRevealerEnabled = Boolean(appConfig.experiments3?.guts_revealer?.enabled)
  return gutsRevealerEnabled && (appConfig.isYandexTeamUser || process.env.NODE_ENV === 'development')
}

function getCreativeBlock(): CreativeBlockParams {
  return appConfig.experiments3?.order_creative_block ?? {}
}
